<template>
  <div class="btn-bottom-bar">
    <el-button type="primary" class="btn-save" @click="saveConfig"
      >保存全部气体通知配置</el-button
    >
    <el-button @click="resetDefault">恢复系统默认分级配置</el-button>
  </div>
  <div class="three-col-container">
    <!-- 左栏：气体事件等级判定（对应原图事件等级判定） -->
    <div class="col-card">
      <div class="card-header">
        <h3>气体事件等级判定</h3>
        <p class="card-desc">
          对接厂区GDS/VOC气体监测事件，分为一级(紧急)、二级(高报)、三级(预警)、四级(提示)4个告警级别
        </p>
      </div>
      <div class="table-inner">
        <div class="table-title-row">
          <span class="col-name">气体事件名称</span>
          <span class="lv1">一级(紧急)</span>
          <span class="lv2">二级(高报)</span>
          <span class="lv3">三级(预警)</span>
          <span class="lv4">四级(提示)</span>
        </div>
        <div class="table-row" v-for="item in gasEventList" :key="item.id">
          <span class="col-name">{{ item.eventName }}</span>
          <div style="text-align: center">
            <el-radio
              v-model="item.level"
              label=""
              class="radio-lv1"
            ></el-radio>
          </div>
          <div style="text-align: center">
            <el-radio
              v-model="item.level"
              label=""
              class="radio-lv2"
            ></el-radio>
          </div>
          <div style="text-align: center">
            <el-radio
              v-model="item.level"
              label=""
              class="radio-lv3"
            ></el-radio>
          </div>
          <div style="text-align: center">
            <el-radio
              v-model="item.level"
              label=""
              class="radio-lv4"
            ></el-radio>
          </div>
        </div>
      </div>
    </div>

    <!-- 中栏：通知频率压缩配置（对应原图通知频率） -->
    <div class="col-card">
      <div class="card-header">
        <h3>告警通知频率压缩</h3>
        <p class="card-desc">
          短时间重复触发的同一条气体告警，自动压缩合并推送，避免消息轰炸
        </p>
      </div>
      <div class="table-inner">
        <div class="table-title-row">
          <span class="col-name">气体事件名称</span>
          <span class="col-time">压缩推送间隔时长</span>
        </div>
        <div class="table-row" v-for="item in gasEventList" :key="item.id">
          <span class="col-name">{{ item.eventName }}</span>
          <div style="text-align: center">
            <el-select v-model="item.interval" class="time-select">
              <el-option label="间隔30秒" value="30s" />
              <el-option label="间隔1分钟" value="1min" />
              <el-option label="间隔3分钟" value="3min" />
              <el-option label="间隔5分钟" value="5min" />
              <el-option label="间隔10分钟" value="10min" />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <!-- 右栏：通知推送方式（对应原图通知方式） -->
    <div class="col-card">
      <div class="card-header">
        <h3>告警通知推送方式</h3>
        <p class="card-desc">
          支持语音播报、弹窗提醒、短信推送、平台消息多种告警提示渠道
        </p>
      </div>
      <div class="table-inner">
        <div class="table-title-row">
          <span class="col-name">气体事件名称</span>
          <span class="col-way">语音播报</span>
          <span class="col-way">大屏弹窗</span>
          <span class="col-way">短信推送</span>
        </div>
        <div class="table-row" v-for="item in gasEventList" :key="item.id">
          <span class="col-name">{{ item.eventName }}</span>
          <div style="text-align: center">
            <el-checkbox v-model="item.voice"></el-checkbox>
          </div>
          <div style="text-align: center">
            <el-checkbox v-model="item.pop"></el-checkbox>
          </div>
          <div style="text-align: center">
            <el-checkbox v-model="item.sms"></el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 底部操作按钮 -->
</template>

<script setup lang="js">
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

// 完整厂区气体告警事件清单（替换原图安防事件，适配GDS/VOC业务）
const gasEventList = ref([
  {
    id:1, eventName:'甲烷气体超标(GDS)', level:'3', interval:'30s', voice:false, pop:true, sms:true
  },
  {
    id:2, eventName:'苯系物VOC超标', level:'1', interval:'30s', voice:true, pop:true, sms:true
  },
  {
    id:3, eventName:'非甲烷总烃超标', level:'2', interval:'1min', voice:true, pop:true, sms:true
  },
  {
    id:4, eventName:'设备离线通讯中断', level:'3', interval:'3min', voice:true, pop:true, sms:false
  },
  {
    id:5, eventName:'传感器浓度瞬时波动', level:'4', interval:'1min', voice:false, pop:true, sms:false
  },
  {
    id:6, eventName:'储罐液位联动气体泄漏', level:'1', interval:'1min', voice:true, pop:true, sms:true
  },
  {
    id:7, eventName:'废气治理设备异常', level:'2', interval:'10min', voice:true, pop:true, sms:true
  },
  {
    id:8, eventName:'监测探头故障', level:'3', interval:'1min', voice:true, pop:true, sms:true
  },
  {
    id:9, eventName:'环保排放口浓度超国标', level:'1', interval:'30s', voice:true, pop:true, sms:true
  },
  {
    id:10, eventName:'气体浓度缓慢爬升预警', level:'3', interval:'1min', voice:false, pop:true, sms:false
  }
])

// 保存配置
const saveConfig = () => {
  ElMessage.success('气体告警通知配置保存完成，实时生效')
}
// 恢复默认
const resetDefault = () => {
  ElMessage.info('已重置为厂区气体分级默认配置')
}
</script>

<style lang="scss" scoped>
/* 三栏布局 */
.three-col-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  height: 100%;
  box-sizing: border-box;
}
.col-card {
  background: var(--card-bg);
  border: 1px solid var(--border-line);
  border-radius: 6px;
  padding: 14px 0;
  display: flex;
  flex-direction: column;
}
.card-header h3 {
  margin: 0 0 6px;
  font-size: 17px;
  color: var(--text-white);
  border-left: 3px solid #409eff;
  padding-left: 10px;
}
.card-desc {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--text-sub);
  line-height: 1.5;
}
.table-inner {
  flex: 1;
  overflow-y: auto;
  background-image: linear-gradient(var(--grid-line) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);
  background-size: 100% 48px, 100% 48px;
}
/* 表头行 */
.table-title-row {
  display: grid;
  padding: 10px 8px;
  background: rgba(22, 42, 82, 0.6);
  font-size: 14px;
  font-weight: 500;
}
/* 左栏表头列宽 */
.col-card:nth-child(1) .table-title-row {
  grid-template-columns: 160px repeat(4, 1fr);
}
.col-name {
  color: #54eaff;
}
.lv1 {
  color: var(--alarm-red);
}
.lv2 {
  color: var(--warning-orange);
}
.lv3 {
  color: var(--lv3-yellow);
}
.lv4 {
  color: var(--primary-blue);
}
/* 中栏表头 */
.col-card:nth-child(2) .table-title-row {
  grid-template-columns: 160px 1fr;
}
.col-time {
  color: #54eaff;
  text-align: center;
}
.time-select {
  width: 130px;
}
/* 右栏表头 */
.col-card:nth-child(3) .table-title-row {
  grid-template-columns: 160px repeat(3, 1fr);
}
.col-way {
  color: #54eaff;
  text-align: center;
}
/* 数据行 */
.table-row {
  display: grid;
  align-items: center;
  padding: 10px 8px;
  min-height: 48px;
  font-size: 13px;
  color: var(--text-sub);
}
.col-card:nth-child(1) .table-row {
  grid-template-columns: 160px repeat(4, 1fr);
}
.col-card:nth-child(2) .table-row {
  grid-template-columns: 160px 1fr;
}
.col-card:nth-child(3) .table-row {
  grid-template-columns: 160px repeat(3, 1fr);
}
.table-row:hover {
  background: rgba(64, 158, 255, 0.06);
}

/* 底部按钮栏 */
.btn-bottom-bar {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}
.btn-save {
  background: linear-gradient(90deg, #2196f3, #00d4ff);
  border: none;
}
</style>
